// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ReloadOutlinedSvg from "@ant-design/icons-svg/es/asn/ReloadOutlined";
import AntdIcon from '../components/AntdIcon';

var ReloadOutlined = function ReloadOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ReloadOutlinedSvg
  }));
};

ReloadOutlined.displayName = 'ReloadOutlined';
export default React.forwardRef(ReloadOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ReloadOutlined.js
// module id = 1697
// module chunks = 0